import React, { useState, useEffect } from 'react';
import { Modal as MaterialModal } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import _ from 'lodash';

import './Modal.scss';
import { RootState } from '../../configs/store';
import Icon from '../Icon/Icon';
import Login from './Login/Login';
import CustomerLogin from './CustomerLogin/CustomerLogin';
import ExistingCustomer from './ExistingCustomer/ExistingCustomer';
import Register from './Register/Register';
import RegisterRetail from './Register/RegisterRetail';
import RegisterRewards from './Register/RegisterRewards';
import RegisterConfirmation from './Register/RegisterConfirmation';
import AccountConfirmation from './Register/AccountConfirmation';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import ConfirmationMessage from './ForgotPassword/ConfirmationMessage';
import ResetPassword from './ForgotPassword/ResetPassword';
import Logout from './Logout/Logout';
import PermutationsTable from './PermutationsTable/PermutationsTable';
import CombinationsModal from './CombinationsModal/CombinationsModal';
import AskConfirmation from './AskConfirmation/AskConfirmation';
import BetConfirmation from './BetConfirmation/BetConfirmation';
import RetailForgotPassword from './RetailForgotPassword/RetailForgotPassword';
import FicaForm from './FicaForm/FicaForm';
import WithdrawModal from './WithdrawModal/WithdrawModal';
import LoginNoRedirect from './Login/LoginNoRedirect';
import ConfirmationModal from 'src/pages/RetailFeatures/CancelTicket/components/ConfirmationModal';
import CancelRequest from 'src/pages/RetailFeatures/CancelTicket/components/CancelRequest';
import RegisterBet from './RegisterBet/RegisterBet';
import NewPassword from './ForgotPassword/ NewPassword';
import SuccessPayment from './PaymentModal/SuccessPayment';
import CancelPayment from './PaymentModal/CancelPayment';
import ErrorPayment from './PaymentModal/ErrorPayment';
import BlockedCustomer from './ForgotPassword/BlockedCustomer';
import TransferUnderBalance from './TransferUnderBalance/TransferUnderBalance';

const COMPONENTS = {
  '#login': Login,
  '#login-no-redirect': LoginNoRedirect,
  '#customer-login': CustomerLogin,
  '#existing-customer': ExistingCustomer,
  '#register': Register,
  '#register-retail': { type: RegisterRetail, wide: true },
  '#register-rewards': { type: RegisterRewards, wide: true },
  '#forgot-password': ForgotPassword,
  '#cancel-ticket': ConfirmationModal,
  '#payout-ticket': ConfirmationModal,
  '#confirmation-message': ConfirmationMessage,
  '#reset-password': ResetPassword,
  '#register-confirmation': RegisterConfirmation,
  '#account-confirmation': AccountConfirmation,
  '#logout': Logout,
  '#permutations': PermutationsTable,
  '#numberPermutation': CombinationsModal,
  '#askConfirmation': AskConfirmation,
  '#betConfirmation': BetConfirmation,
  '#recover-password': RetailForgotPassword,
  '#fica-form': FicaForm,
  '#register-bet': RegisterBet,
  '#withdraw-modal': WithdrawModal,
  '#new-password': NewPassword,
  '#blocked-customer': BlockedCustomer,
  '#payment-success': SuccessPayment,
  '#payment-cancel': CancelPayment,
  '#payment-error': ErrorPayment,
  '#cancel-request': CancelRequest,
  '#transferUnderBalance': TransferUnderBalance
};

function Modal() {
  const { t } = useTranslation('common');
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { modal } = useSelector((state: RootState) => state.content);

  const [isWide, setIsWide] = useState('');
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [children, setChildren] = useState<React.ReactNode>(null);

  const onClose = () => {
    if (location.hash?.length > 1) {
      history.replace(location.pathname);
    } else {
      dispatch.content.modalType('');
    }
  };

  useEffect(() => {
    const hasQuery = location.hash?.length > 1 && location.hash.includes('?');
    let hash = location.hash?.length > 1 && !hasQuery ? location.hash : location.hash.split('?')[0];
    if (modal.length > 1 && location.hash?.length === 0) {
      hash = modal;
    }

    const FormModal = _.has(COMPONENTS[hash], 'type') ? COMPONENTS[hash]?.type : COMPONENTS[hash];
    setIsWide(COMPONENTS[hash]?.wide);
    const translation =  hash.substr(1) === 'login-no-redirect' ? 'login' : hash.substr(1);

    if (FormModal) {
      setTitle(i18next.exists(`modal.${ translation }Title`) ? t(`modal.${ translation }Title`) : '');
      setSubTitle(i18next.exists(`modal.${ hash.substr(1) }SubTitle`) ? t(`modal.${ hash.substr(1) }SubTitle`) : '');
      setChildren(<FormModal close={ onClose } />);
    } else {
      setTitle('');
      setSubTitle('');
      setChildren(null);
    }
  }, [modal, location.hash]);

  return (
    <div>
      {
        children && (
          <MaterialModal
            disableEscapeKeyDown={ true }
            open={ true }
            onClose={ onClose }
            className="modal"
          >
            <div
              className={
                classNames({
                  'modal-container': true,
                  'modal-container--wide': isWide
                })
              }
            >
              <Icon icon="close" className="modal-container__close" onClick={ onClose } />
              <div className="modal-container__header">
                <span className="modal-container__title">{ title }</span>
                { subTitle && <span className="modal-container__sub-title">{ subTitle }</span> }
              </div>
              <div className="modal-container__body">{ children }</div>
            </div>
          </MaterialModal>
        )
      }
    </div>
  );
}

export default Modal;
